<template >
  <div style="">
    <div  >

      <div style="top:-156px;position:fixed;">
        <div style="z-index:0;position:relative;width:100%;height:calc(100vh + 200px);margin-left:0;background: rgb(154,255,186);background: linear-gradient(40deg, rgb(255 255 255 / 72%) 0%, rgb(2 4 4) 100%);">
          <video  loop="" muted="" autoplay=""  style="opacity: 0.2;pointer-events: none;z-index: -1;height:calc(100vh + 200px);">">
            <source :src="require('../assets/white_flare.webm')" type="video/webm">

          </video>



        </div>




      </div>

      <v-tabs
              v-model="tab"
              style="margin-top:80px;"
              dark
              background-color="transparent"
              class="mx-auto"
              centered
      >
        <v-tab
        >
          Kontakt
        </v-tab>
        <v-tab
        >
          Tjänsten
        </v-tab>
      </v-tabs>

      <v-tabs-items style="background: transparent;" v-model="tab">
        <v-tab-item
                style="background: transparent;"

        >
          <v-row class="mx-auto" style="margin-top:40px;max-width:1300px;"  align="center" justify="center">
            <v-col align="center" cols="12" style="">
              Har du en fråga om Hihat? Skriv till <v-chip
                    dark
                    label
                    style="background: linear-gradient(40deg, rgb(106, 187, 187) 0%, rgb(47, 218, 158) 100%)"
                    text
                    class="mx-auto"
            >
              <v-icon left>mail</v-icon>info@hihat.io
            </v-chip> eller fråga i vår Discord

            </v-col>
            <v-col align :cols="$vuetify.breakpoint.mdAndUp? '4':'12'">
              <v-card
                      flat
                      class="mx-auto"
                      max-width="400"
                      style="background: transparent;"
                      :style="{'transform':$vuetify.breakpoint.mdAndUp?'':'scale(0.8);'}"
              >
                <v-img
                        class="white--text align-end"
                        height="400x"
                        src="/api/images/carl2.png"
                        style="mix-blend-mode: lighten"
                        eager

                >
                </v-img>
                <v-card-title style="color:white;" >Carl</v-card-title>

                <v-card-subtitle style="color:white;"  class="pb-0">Utvecklare</v-card-subtitle>

                <v-card-text  style="color:white;" >
                  <i>Carl programmerar och spelar gärna WoW tillsammans med Mika, så länge det är VANILLA!</i>
                </v-card-text>

                <v-card-actions>
                  <v-chip
                          dark
                          label
                          style="background: linear-gradient(40deg, rgb(106, 187, 187) 0%, rgb(47, 218, 158) 100%)"
                          text
                          class="mx-auto"
                  >
                    <v-icon left>mail</v-icon>carl@hihat.io
                  </v-chip>


                </v-card-actions>
              </v-card>
            </v-col>
            <v-col style="text-align: center;min-height: 600px;" :cols="$vuetify.breakpoint.mdAndUp? '4':'12'">

            <iframe style="filter:saturate(0);min-height: 600px;" class="discord_frame"  src="https://discord.com/widget?id=550437580722667540&theme=dark" width="350" height="400" allowtransparency="true" frameborder="0" sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"></iframe>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mdAndUp? '4':'12'">
              <v-card
                      class="mx-auto"
                      max-width="400"
                      style="background: transparent;"
                      flat
                      :style="{'transform':$vuetify.breakpoint.mdAndUp?'':'scale(0.8);'}"

              >
                <v-img
                        class="white--text align-end"
                        height="400x"
                        src="/api/images/mika2.png"
                        style="mix-blend-mode: lighten"
                        eager

                >
                </v-img>
                <v-card-title style="color:white;"  class="">Mika</v-card-title>

                <v-card-subtitle style="color:white;" class="pb-0">Community Manager</v-card-subtitle>

                <v-card-text style="color:white;" >
                  <i>Mika kan allt om alla streams men tittar helst på Forsen. Han peakade 2013 när han rappade mot Dirt Nasty.</i>
                </v-card-text>

                <v-card-actions>
                  <v-chip
                          dark
                          label
                          style="background: linear-gradient(40deg, rgb(106, 187, 187) 0%, rgb(47, 218, 158) 100%)"
                          text
                          class="mx-auto"
                  >
                    <v-icon left>mail</v-icon>mika@hihat.io
                  </v-chip>


                </v-card-actions>
              </v-card>
            </v-col>



          </v-row>

        </v-tab-item>
        <v-tab-item>
          <v-card
                  class="mx-auto"
                  max-width="800"
                  style="background: transparent;margin-top:40px;"
                  flat
                  dark



          >

            <v-card-title style="color:white;"  class=""><v-spacer></v-spacer><span style="text-align: center;">Donationer</span><v-spacer></v-spacer></v-card-title>


            <v-card-text style="text-align: center;">
              Den totala avgiften för tjänsten är 3.25 SEK + 3.25% per notis.
            </v-card-text>
            <v-simple-table dark style="max-width:800px;background: linear-gradient(40deg, rgba(96,55,170,0.72) 0%, rgb(41,160,118) 100%);min-height:0px !important;">
              <template v-slot:default>
                <thead>
                <tr>
                  <th style="color:white !important;" class="text-left"></th>
                  <th style="color:white !important;" class="text-left"><b>50 kr</b></th>
                  <th style="color:white !important;" class="text-left"><b>100 kr</b></th>
                  <th style="color:white !important;" class="text-left"><b>200 kr</b></th>






                </tr>
                </thead>
                <tbody>
                <tr >
                  <td>Streamer får</td>
                  <td>45.2 kr</td>
                  <td>93.5 kr</td>
                  <td>190.25</td>




                </tr>
                <tr >
                  <td>Avgift</td>
                  <td>4.8 kr</td>
                  <td>6.5 kr</td>
                  <td>9.8 kr</td>




                </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-card-text style="text-align: right;">
              (före skatt)
            </v-card-text>



          </v-card>
          <v-card
                  class="mx-auto"
                  max-width="800"
                  style="background: transparent;"
                  flat
                  dark



          >

            <v-card-title style="color:white;"  class=""><v-spacer></v-spacer><span style="text-align: center;">Hicards</span><v-spacer></v-spacer></v-card-title>



            <v-card-text style="text-align: center;">
              Avgiften vid försäljning av Hicards beror på din typ av medlemskap.
            </v-card-text>
            <v-simple-table dark style="max-width:800px;background: linear-gradient(40deg, rgba(96,55,170,0.72) 0%, rgb(41,160,118) 100%);">
              <template v-slot:default>
                <thead>
                <tr>
                  <th style="color:white !important;" class="text-left"></th>
                  <th style="color:white !important;" class="text-left"><b>10%</b></th>
                  <th style="color:white !important;" class="text-left"><b>15%</b></th>
                  <th style="color:white !important;" class="text-left"><b>20%</b></th>






                </tr>
                </thead>
                <tbody>
                <tr >
                  <td>Avgift</td>
                  <td>4.9 kr</td>
                  <td>7.35 kr</td>
                  <td>9.8 kr</td>




                </tr>

                </tbody>
              </template>
            </v-simple-table>
            <v-card-text style="text-align: right;">
              (före skatt och för ett paket Hicards à 49 kr)
            </v-card-text>



          </v-card>
          <v-card
                  class="mx-auto"
                  max-width="800"
                  style="background: transparent;margin-top:60px;"
                  flat
                  dark



          >

            <v-card-title style="color:white;"  class=""><v-spacer></v-spacer><span style="text-align: center;">FAQ</span><v-spacer></v-spacer></v-card-title>


            <v-subheader style="color:white;" class="py-0">Kan jag vara anonym på Hihat?</v-subheader>
            <v-card-text style="" class="py-0">
              Ja! Välj Hihat-Classic så slipper du läcka dina uppgifter.
            </v-card-text>
            <v-subheader style="color:white;" class="py-0">Varför finns det en avgift?</v-subheader>
            <v-card-text style="" class="py-0">
              Då Swish-licenser och allt annat som krävs för att driva Hihat kostar pengar måste även vi ha en avgift för att inte bli ruinerade. Transaktioner på de flesta plattformar har någon form av avgift, ofta dold.
            </v-card-text>
            <v-subheader style="color:white;" class="py-0">Ska jag som streamer betala moms på donationer via Hihat?</v-subheader>
            <v-card-text style="" class="pt-0">
              <b>Nej!</b> Donationer via Hihat är momsbefriade.
            </v-card-text>



          </v-card>
        </v-tab-item>
      </v-tabs-items>


































    </div>


  </div>
</template>

<script>
  export default {
    name: 'About',
    components: {

    },
    data(){
      return {
        tab:0
      }

    },
    computed:{

      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
      query () {
        return this.$route.query
      }
    },
    methods:{
      letsgo:function(){
        this.$store.state.APP.SHOW_LOGIN=true;
      },



    },
    watch:{
      tab: function (newVal) {
        if(newVal===0){
          window.history.replaceState(null, null, window.location.pathname);
        }
        else{
          window.history.replaceState(null, null, window.location.pathname+"?k=ek");

        }
      },
      query:function(newVal){
        if(Object.prototype.hasOwnProperty.call(newVal, "k")){

          this.tab=1;
        }
        else{
          this.tab=0;
        }

      }
    },
    mounted:function(){
      document.title="Hihat";
      if(this.$route.query.k==="ek"){
        this.tab=1;
      }


    }

  }
</script>

<style>
  .discord_frame:hover {
    transition-duration: 500ms;
    filter:saturate(100%) !important;
  }

  .lift_me_up> * img{
    top:-200px;
  }

  @keyframes spin {
    from {
      transform:rotate(0deg);
    }
    to {
      transform:rotate(360deg);
    }
  }

  .spin_da_guthen{
    animation-name: spin;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    /* transform: rotate(3deg); */
    /* transform: rotate(0.3rad);/ */
    /* transform: rotate(3grad); */
    /* transform: rotate(.03turn);  */
  }

  .theme--dark.v-data-table tbody tr:hover{
    background: rgba(255,255,255,0.1) !important;
  }
</style>
